import { provideApollo } from 'apollo-angular';
import { InMemoryCache, ApolloLink } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { HttpLink } from 'apollo-angular/http';
import { provideHttpClient } from '@angular/common/http';
import { inject } from '@angular/core';

export function provideGraphQL() {
  return [
    provideHttpClient(),
    provideApollo(() => {
      const httpLink = inject(HttpLink);

      // 1. Middleware to attach the session header to outgoing requests
      const authLink = setContext((operation, context) => {
        const session = localStorage.getItem('woo-session');
        if (session) {
          return {
            headers: {
              ...context['headers'],
              'woocommerce-session': `Session ${session}`
            }
          };
        }
        return {};
      });

      // 2. Afterware to capture the session header from incoming responses
      const afterwareLink = new ApolloLink((operation, forward) => {
        return forward(operation).map(response => {
          const context = operation.getContext();
          // Angular's HttpLink stores the HttpResponse in context['response']
          const headers = context['response']?.headers;
          if (headers) {
            const session = headers.get('woocommerce-session');
            if (session) {
              localStorage.setItem('woo-session', session);
            }
          }
          return response;
        });
      });

      return {
        cache: new InMemoryCache({
          possibleTypes: {
            Product: ['SimpleProduct', 'VariableProduct', 'ExternalProduct', 'GroupProduct']
          }
        }),
        link: authLink.concat(afterwareLink.concat(httpLink.create({ uri: 'https://wp.perumental.com/graphql' })))
      };
    }),
  ];
}
